<template>
  <bimButton
    v-bind="$attrs"
    class="button-big"
    size=l
    @click="$emit('click')"
  />
</template>

<script>
import bimButton from '@/components/form/bimButton/bimButton'
export default {
  components: {
    bimButton
  }
}
</script>

<style lang="scss" scoped>
.button-big {
  width: 100%;
  height: 4.8rem;
  font-size: 1.4667rem;
  font-weight: normal;
}
</style>
